module.exports = __webpack_public_path__ + "static/img/pic_ps.88175e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productServices/productOperation/pic_ps.png
// module id = SZID
// module chunks = 0